export default "__VITE_ASSET__BtpCeBrb__"